'use strict';

exports.__esModule = true;
exports.default = findFixedTo;
function findFixedTo(table) {
  if (table && table.firstChild.firstChild.classList.contains('md-data-table__scroll-wrapper')) {
    return {
      x: table,
      y: table.firstChild.firstChild
    };
  }

  return table;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/DataTables/findFixedTo.js
// module id = 334
// module chunks = 213534597649335